import React, {Component} from 'react';
import { combineReducers, createStore } from 'redux';
import { connect } from 'react-redux';
import Helmet from "react-helmet";
import { browserHistory } from 'react-router';

import { loadUserFromToken } from '../store/actions/authentication';

import SimpleHeader from '../containers/SimpleHeader';
import Footer from '../components/Footer';

function mapStateToProps(state) {
   return {
    isAuthenticated: state.authentication.isAuthenticated,
    user: state.user.data,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadUserFromToken: () => {
      dispatch(loadUserFromToken())
    }
  }
}

class AppContainer extends Component {

  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentWillMount() {
    this.props.loadUserFromToken();
  }

  render() {
    let { children, route, user, isAuthenticated } = this.props;

    return (
      <div>
        <Helmet
          meta={[
            { property: "og:site_name", content: route.meta.site_name},
            { property: "og:type", content: 'website'},
          ]}
        />
        <SimpleHeader />
        <div className="content_wrapper">
          {children}
        </div>
        <Footer siteName={route.meta.site_name}/>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);



// WEBPACK FOOTER //
// ./src/views/appContainer.js